import { useEffect, useState } from "react";
import Toast from "../../functions/classes/toast.class.js";
import {
  isInDevelopmentMode,
  postData,
} from "../../functions/helper/helpers.functions.js";

/**
 * Dieser Effect sollte immer verwendet werden bei einem reinen Upload. Wenn keine gute Verbindung
 * besteht schmeißt dieser Effekt die richtigen Meldungen und versucht es erneut!
 * @param {UploadItem} uploadItem
 */
export default function useUpload(uploadItem, setToast) {
  // --- Constants ---
  const uploadInterval = 15000; // 15 sec

  // --- States ---
  const [failedItem, setFailedItem] = useState(null);

  // --- Functions ---
  /**
   * @param {UploadItem} item
   */
  const handlePost = (item) => {
    console.log(item.post);
    postData(item.url, item.post)
      .then((response) => {
        if (!isInDevelopmentMode()) return;

        let status = response.status;
        if (status >= 200 && status < 300) {
          setToast(
            new Toast(
              item.name,
              `${item.name} wurde erfolgreich hochgeladen`,
              Toast.toastTypes.success
            )
          );
          console.log("%c Upload successful", "background: green", response);
          return;
        }
        if (status >= 400 && status < 400) {
          setToast(
            new Toast(item.name, "Status Code 4XX", Toast.toastTypes.error)
          );
          console.log("%c Upload unsuccessful", "background: red", response);
          return;
        }
        if (status >= 500 && status < 600) {
          setToast(
            new Toast(item.name, "Status Code 5XX", Toast.toastTypes.error)
          );
          console.log("%c Upload unsuccessful", "background: red", response);
          return;
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log("%c Upload failed", "background: red", error.response);
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // wenn z.b. kein internet da ist!
          console.log(
            "%c No Reponse from Upload",
            "background: red",
            error.request.responseType,
            error.request.status,
            error.request,
            error.response
          );
        } else {
          // Irgendwas im setup passiert das einen error getriggert hat, hier sollte nicht nochmal
          // versucht werden hochzuladen
          console.log(
            "%c Something wrong in the request setup",
            "background: red",
            error
          );
        }
        if (item.shouldRetry) setFailedItem(item);
      });
  };

  // --- Effects ---
  useEffect(() => {
    if (uploadItem == null) return;
    handlePost(uploadItem);
  }, [uploadItem]);

  useEffect(() => {
    if (failedItem == null || (failedItem && !failedItem.shouldRetry)) return;

    setTimeout(() => {
      handlePost(failedItem);
      failedItem.incrementTimesFailed();
      setFailedItem(null);
    }, uploadInterval);

    // wenn es bereits einmal gefailed ist kein Toast mehr!
    if (failedItem.timesFailed) return;
    setToast(
      new Toast(
        failedItem.name,
        `${failedItem.name} konnte nicht hochgeladen werden, es wird aber in 15 sekunden erneut versucht`,
        Toast.toastTypes.error
      )
    );
  }, [failedItem]);
}
